import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTestTube2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTestTube2"><Path d="M10 3.5H3.5V11" stroke="currentColor"/><Path d="M12.75 20.5L20.5 20.5L20.5 14" stroke="currentColor"/><Path d="M19.0003 9L9.2503 18.75C8.14573 19.8546 6.35487 19.8546 5.2503 18.75C4.14573 17.6454 4.14573 15.8546 5.2503 14.75L15.0003 5" stroke="currentColor"/><Path d="M13.75 3.25L20.75 10.25" stroke="currentColor"/><Path d="M8.5 11.75H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconTestTube2;
